module.exports = __webpack_public_path__ + "static/laser_baby-3166abcf09bbc63f33c6b01bce951a2f.png";